import React, { Component } from 'react';

import { Container, Offcanvas, Row, Col,  Form } from 'react-bootstrap';

import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';
import CommonFile from '../components/CommonFile';
import CustomDatePicker from "../components/CommonDatePicker";
import CommonButton from '../components/CommonButton';

import CommonAlert from '../components/CommonAlert';
import CommonLoadingBar from '../components/CommonLoadingBar';

import * as Actions from '../actions/ActionCenter';

import * as fn from '../../library/function';
import * as helper from '../../library/helper';
import * as util from '../../library/utilitys';

import SimpleBar from 'simplebar-react';

import InlineEECNetsDataMission from '../inline/InlineEECNetsDataMission';
import InlineEECNetsDataNetworkOperation from '../inline/InlineEECNetsDataNetworkOperation';

import InlineEECNetsDataNetworkPerformanceType from '../inline/InlineEECNetsDataNetworkPerformanceType';

import InlineEECNetsDataFuturePlans from '../inline/InlineEECNetsDataFuturePlans';
import InlineEECNetsDataNetworkPartner from '../inline/InlineEECNetsDataNetworkPartner';
import InlineEECNetsDataIllustration from '../inline/InlineEECNetsDataIllustration';
import InlineEECNetsDataPublicData from '../inline/InlineEECNetsPublicData';

class InputEECNetsData extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedDate: new Date(),
        };
    }

    handleDateChange = (date) => { this.setState({ selectedDate: date }); };

    prepareInputs = async () => {
        const { URL, Action, Inputs, onUpdateState, UserCookie } = this.props;
        const isUpdateMode = Action.Mode === 'update';

        let updatedInputs = fn.setRequiredPrimaryKey(Inputs, isUpdateMode);

        if (Action.Mode === 'new' && UserCookie?.academy_id) {
            updatedInputs.academy_id = {
            ...updatedInputs.academy_id,
            value: UserCookie.academy_id
            };
        }

        if(Action.Mode === 'new'){
            let field = 'seq';
            let result = await Actions.getMaxSequence(this.updateState, URL + '/get-max-sequence', {sequenceField: field});
            if(result.success){ updatedInputs[field] = { 
                    ...updatedInputs[field],
                    value: result.seq
                };
            }
        }        

        onUpdateState('Inputs', updatedInputs);
    }   
    
    componentDidUpdate = async (prevProps) => {
        if (fn.shouldPrepareInputs(prevProps.Action, this.props.Action)) {
            await this.prepareInputs();
        }
    }
    
    render = () => {
        let props = this.props;

        let { onInputChange, onCloseAlert, onSubmit, onDiscardSubmit, onSetEdit, onPreviewFile, onDeleteFile } = props;

        let { App, Action, Inputs, InputGroup, Masterbase, Operation, UserCookie } = props;

        let { Submit } = Operation;
        
        let { show, mode } = Action.OffCanvas;

        let isLoading = Action.Loading.submit;

        return (
                <Offcanvas 
                    show={show}
                    placement="end" 
                    style={{ '--bs-offcanvas-width': '100vw' }}
                    scroll={true}
                    backdrop={Submit ? "static" : true}
                    onHide={(e) => props.onClose(e)}
                >

                  <Offcanvas.Header closeButton className="border-bottom custom-offcanvas-header">
                        <Offcanvas.Title className="custom-offcanvas-header offcanvas-title"><i className={`${App.icon} text-white me-2`}/>{App.title}</Offcanvas.Title>
                    </Offcanvas.Header>

                     <Offcanvas.Body className="custom-offcanvas-body">
                        
                        <CommonAlert 
                            alert={Action.Alert} 
                            callback={(e) => onCloseAlert(e)}
                        />
                        
                        <SimpleBar id="inputs" className="simple-bar-input">

                            <Container fluid className="data-table-container">
                        
                                <Row>
                                    <Col md={{ span: 10, offset: 1 }} className="eb-form-container">
                                        
                                        <Row>
                                            <Col md={12}  className="d-flex flex-column align-items-center text-center">
                                                <h5>แบบฟอร์มข้อมูลศูนย์เครือข่าย (EEC Nets)</h5>
                                                <h5 className="mt-3">การพัฒนาบุคลากรในพื้นที่ EEC เพื่อการเผยแพร่ต่อสาธารณะ</h5>
                                            </Col>
                                        </Row>

                                        <Row className="mt-3">
                                            <Col md={2} className="mb-3">{util.formatLabel('1. ', Inputs.academy_id)}</Col>
                                            <Col md={6} className="mb-3">
                                                <CommonSelect
                                                    element="Inputs"
                                                    input={Inputs.academy_id}
                                                    option={{source: 'db', data: Masterbase?.academy}}
                                                    hr={false}
                                                    callback={(e, element) => onInputChange(e, element)} 
                                                    disabled={!['0', '1', '2'].includes(UserCookie.types)}                                     
                                                />
                                            </Col>
                                        </Row> 

                                        <Row>
                                            <Col md={2} className="mb-3">{util.formatLabel('2. ', Inputs.name)}</Col>
                                            <Col md={6} className="mb-3">
                                                <CommonInput
                                                    element="Inputs"
                                                    input={Inputs.name}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)} 
                                                />                                    
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={2} className="d-flex align-items-start justify-content-end mb-3 align-top">{util.formatLabel(null, Inputs.logo)}</Col>
                                            <Col md={10} className="mb-3">
                                                <CommonFile
                                                    element="Inputs"
                                                    input={Inputs.logo}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)} 

                                                    previewFile={(e) => onPreviewFile(e)} 
                                                    deleteFile={(e) => onDeleteFile(e, Inputs.id)} 
                                                />                                            
                                            </Col>
                                        </Row> 
                                        <Row>
                                            <Col md={2} className="d-flex align-items-start justify-content-end mb-3 align-top">{util.formatLabel(null, Inputs.background)}</Col>
                                            <Col md={10} className="mb-3">
                                                <CommonFile
                                                    element="Inputs"
                                                    input={Inputs.background}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)} 

                                                    previewFile={(e) => onPreviewFile(e)} 
                                                    deleteFile={(e) => onDeleteFile(e, Inputs.id)} 
                                                />                                            
                                            </Col>
                                        </Row>                                        

                                        <Row>
                                            <Col md={12} className="mb-3">{util.formatLabel('3. ', Inputs.description)}</Col>
                                        </Row>  
                                        <Row>
                                            <Col md={12} className="mb-3">
                                                <CommonInput
                                                    element="Inputs"
                                                    input={Inputs.description}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)} 
                                                />                                              
                                            </Col>
                                        </Row>                                                                               

                                        <Row>
                                            <Col md={12} className="mb-3">{util.formatLabel('4. ', {label: 'ภารกิจ', validator: {required: true}})}</Col>
                                        </Row>    
                                        <Row>
                                            <Col md={{ span: 12, offset: 0 }} className="mb-3">
                                                <InlineEECNetsDataMission 
                                                    fkId="eec_nets_id"
                                                    fkVal={Inputs.id.value}
                                                />                                                
                                            </Col>                                        
                                        </Row> 

                                        <Row>
                                            <Col md={12} className="mb-3">{util.formatLabel('5. ', {label: 'การดำเนินการของศูนย์', validator: {required: true}})}</Col>
                                        </Row>     
                                        <Row>
                                            <Col md={{ span: 12, offset: 0 }} className="mb-3">
                                                <InlineEECNetsDataNetworkOperation
                                                    fkId="eec_nets_id"
                                                    fkVal={Inputs.id.value}
                                                />
                                            </Col>                                        
                                        </Row>   

                                        <Row>
                                            <Col md={12} className="mb-3">{util.formatLabel('6. ', {label: 'ผลการดำเนินงานของศูนย์ที่ผ่านมา', validator: {required: false}})}</Col>
                                        </Row>  
                                        <Row>
                                            <Col md={12} className="mb-3">{util.formatLabel('6.1 ', {label: 'การพัฒนาทักษะบุคลากร (EEC Model Type B)', validator: {required: false}})}</Col>
                                        </Row>                                             
                                        <Row>
                                            <Col md={{ span: 12, offset: 0 }} className="mb-3">
                                                <InlineEECNetsDataNetworkPerformanceType
                                                    fkId="eec_nets_id"
                                                    fkVal={Inputs.id.value}
                                                    filterSet={
                                                        [{search: 'network_performance_types', input: 'types', value: '1'}]
                                                    }
                                                />
                                            </Col>                                        
                                        </Row>  

                                        <Row>
                                            <Col md={12} className="mb-3">{util.formatLabel('6.2 ', {label: 'การพัฒนาทักษะบุคลากรภาคอุตสาหกรรม (นอกเหนือจากรูปแบบ EEC Model Type B)', validator: {required: false}})}</Col>
                                        </Row>                                             
                                        <Row>
                                            <Col md={{ span: 12, offset: 0 }} className="mb-3">
                                               <InlineEECNetsDataNetworkPerformanceType
                                                    fkId="eec_nets_id"
                                                    fkVal={Inputs.id.value}
                                                    filterSet={
                                                        [{search: 'network_performance_types', input: 'types', value: '2'}]
                                                    }
                                                />
                                            </Col>                                        
                                        </Row>  

                                        <Row>
                                            <Col md={12} className="mb-3">{util.formatLabel('6.3 ', {label: 'การขับเคลื่อนการศึกษาเพื่อรองรับการพัฒนาอุตสาหกรรมตามขอบเขตการดำเนินงานของศูนย์', validator: {required: false}})}</Col>
                                        </Row>                                             
                                        <Row>
                                            <Col md={{ span: 12, offset: 0 }} className="mb-3">
                                               <InlineEECNetsDataNetworkPerformanceType
                                                    fkId="eec_nets_id"
                                                    fkVal={Inputs.id.value}
                                                    filterSet={
                                                        [{search: 'network_performance_types', input: 'types', value: '3'}]
                                                    }
                                                />
                                            </Col>                                        
                                        </Row>  

                                        <Row>
                                            <Col md={12} className="mb-3">{util.formatLabel('7. ', {label: 'แผนการดำเนินงาน (ระบุแผนการขยายงานของศูนย์ฯ และ งบประมาณ)', validator: {required: true}})}</Col>
                                        </Row>                                             
                                        <Row>
                                            <Col md={{ span: 12, offset: 0 }} className="mb-3">
                                                <InlineEECNetsDataFuturePlans
                                                    fkId="eec_nets_id"
                                                    fkVal={Inputs.id.value}
                                                />   
                                            </Col>                                        
                                        </Row>  

                                        <Row>
                                            <Col md={12} className="mb-3">{util.formatLabel('8. ', {label: 'หน่วยงานพันธมิตรของศูนย์ฯ', validator: {required: true}})}</Col>
                                        </Row>                                             
                                        <Row>
                                            <Col md={{ span: 12, offset: 0 }} className="mb-3">
                                                <InlineEECNetsDataNetworkPartner
                                                    fkId="eec_nets_id"
                                                    fkVal={Inputs.id.value}
                                                />
                                            </Col>                                        
                                        </Row>  

                                        <Row>
                                            <Col md={12} className="mb-3">{util.formatLabel('9. ', {label: 'ภาพประกอบ', validator: {required: false}})}</Col>
                                        </Row>                                             
                                        <Row>
                                            <Col md={{ span: 12, offset: 0 }} className="mb-3">
                                                <InlineEECNetsDataIllustration
                                                    fkId="eec_nets_id"
                                                    fkVal={Inputs.id.value}
                                                />
                                            </Col>                                        
                                        </Row>  

                                        <Row>
                                            <Col md={12} className="mb-3">{util.formatLabel('10. ', {label: 'เอกสารเผยแพร่/นำเสนอ', validator: {required: false}})}</Col>
                                        </Row>                                             
                                        <Row>
                                            <Col md={{ span: 12, offset: 0 }} className="mb-3">
                                                <InlineEECNetsDataPublicData
                                                    fkId="eec_nets_id"
                                                    fkVal={Inputs.id.value}
                                                />
                                            </Col>                                        
                                        </Row>   

                                        <Row>
                                            <Col md={12} className="mb-3">{util.formatLabel('11. ', {label: 'ช่องทางติดต่อศูนย์', validator: {required: false}})}</Col>
                                        </Row>                                             
                                        <Row>
                                            <Col md={2} className="d-flex align-items-start justify-content-end mb-3 align-top">{util.formatLabel(null, Inputs.location)}</Col>
                                            <Col md={10} className="mb-3">
                                                <CommonInput
                                                    element="Inputs"
                                                    input={Inputs.location}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)} 
                                                    disabled={false}
                                                />
                                            </Col>
                                        </Row> 

                                       <Row>
                                            <Col md={2} className="mb-3 text-end">{util.formatLabel(null, Inputs.contact)}</Col>
                                            <Col md={3} className="mb-3">
                                                <CommonInput
                                                    element="Inputs"
                                                    input={Inputs.contact}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)} 
                                                    disabled={false}
                                                />
                                            </Col>
                                            <Col md={1} className="mb-3 text-end">{util.formatLabel(null, Inputs.email)}</Col>
                                            <Col md={3} className="mb-3">
                                                <CommonInput
                                                    element="Inputs"
                                                    input={Inputs.email}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)} 
                                                    disabled={false}
                                                />
                                            </Col>                                            
                                        </Row>                                           

                                        <Row>
                                            <Col md={2} className="mb-3">{util.formatLabel('10. ', Inputs.seq)}</Col>
                                            <Col md={1} className="mb-3">
                                                <CommonInput
                                                    element="Inputs"
                                                    input={Inputs.seq}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)} 
                                                    disabled={true}
                                                />                                    
                                            </Col>
                                        </Row>   

                                        <Row>
                                            <Col md={2} className="mb-3">{util.formatLabel(null, Inputs.status)}</Col>
                                            <Col md={2} className="mb-3">
                                                <CommonSelect
                                                    element="Inputs"
                                                    input={Inputs.status}
                                                    option={{source: 'options', section: 'status', item: 'default'}}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)} 
                                                />                                 
                                            </Col>
                                        </Row>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          


                                    </Col>
                                </Row>  

                            </Container>                          
                            
                        </SimpleBar>

                    </Offcanvas.Body>   

                    <div className="offcanvas-footer d-flex flex-column border-top bg-light p-3">
                        
                        <CommonLoadingBar isLoading={isLoading} />

                        <div className="d-flex justify-content-end mt-2">
                            <CommonButton 
                                task={mode} 
                                disabled={isLoading ? true : Submit ? false : true}
                                callback={async (e) => { 
                                    await onSubmit(e);
                                }} 
                            />

                            {Action.Mode === 'new' && (
                                <CommonButton 
                                    task="discard" 
                                    inlineClass="ms-1" 
                                    disabled={isLoading} 
                                    callback={(e) => onDiscardSubmit(false)} 
                                />
                            )}
                        </div>
                    </div>                                  

                </Offcanvas>    
        )
    }
}

export default InputEECNetsData;    